import React from "react";
import toast from "react-hot-toast";
import "./editor-feedback.scss";

export const EDITOR_SAVED_EVENT = "easybar-editor-saved";

export function focusEditorField(name: string) {
  const field = document.querySelector<HTMLElement>(`.modal [data-editor-field="${name}"]`);
  field?.focus();
  field?.scrollIntoView({ block: "center", behavior: "smooth" });
}

export function showEditorSaved(kind: "rebar" | "net" | "pile", id: number, edit: boolean, t: any, rtl: boolean) {
  if (!id) return;
  // Dismiss the iOS keyboard only after a confirmed save; validation keeps focus.
  if (window.matchMedia("(max-width: 991.98px)").matches && document.activeElement instanceof HTMLElement && document.activeElement.closest(".mobile-tool-editor-shell")) {
    document.activeElement.blur();
  }
  window.dispatchEvent(new CustomEvent(EDITOR_SAVED_EVENT, { detail: { kind, id } }));
  toast((notification) => (
    <div className="editor-success-message" dir={rtl ? "rtl" : "ltr"}>
      <span>{t(`editor ${kind} ${edit ? "updated" : "added"}`, { ns: "tool" })}</span>
      <button type="button" aria-label={t("editor close message", { ns: "tool" })} onClick={() => toast.dismiss(notification.id)}>×</button>
    </div>
  ), {
    id: "order-editor-result", duration: 3800, position: "top-center",
    ariaProps: { role: "status", "aria-live": "polite" },
    style: { maxWidth: "calc(100vw - 32px)", marginTop: "max(56px, env(safe-area-inset-top))" },
  });
  let attempts = 0;
  const reveal = () => {
    const item = document.querySelector<HTMLElement>(`[data-order-item-id="${id}"]`);
    if (!item || item.getBoundingClientRect().height === 0) {
      if (++attempts < 20) window.setTimeout(reveal, 100);
      return;
    }
    item.scrollIntoView({ behavior: "smooth", block: "center" });
    item.classList.add("editor-saved-item");
    window.setTimeout(() => item.classList.remove("editor-saved-item"), 3800);
  };
  window.setTimeout(reveal, 350);
}
